import { render } from "./addDoctor.vue?vue&type=template&id=525232c3&scoped=true"
import script from "./addDoctor.vue?vue&type=script&lang=js"
export * from "./addDoctor.vue?vue&type=script&lang=js"

import "./addDoctor.vue?vue&type=style&index=0&id=525232c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525232c3"]])

export default __exports__